import React, { useEffect, useState } from "react";
import { fetchProjectDetailsOptions, fetchSectionsForProjectDetails } from "./lettersApi";

/**
 * projectDetailsScopeId: pass a ProjectDetails id when this filter bar is mounted inside a
 * single project's tab — hides the project dropdown and locks filtering to that project.
 */
export default function LettersFilterBar({ filters, setFilter, setFilters, clearFilters, projectDetailsScopeId }) {
  const [projectDetailsList, setProjectDetailsList] = useState([]);
  const [sections, setSections] = useState([]);
  const [sectionsLoading, setSectionsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState(filters.search);

  useEffect(() => {
    fetchProjectDetailsOptions()
      .then(setProjectDetailsList)
      .catch(() => setProjectDetailsList([]));
  }, []);

  const activeProjectDetailsId = projectDetailsScopeId || filters.project_details;

  // Sections depend on the selected project — fetched fresh via the real
  // /dpr/projectfilterbyid/<id>/ endpoint, not a nested field on the project list.
  useEffect(() => {
    if (!activeProjectDetailsId) {
      setSections([]);
      return;
    }
    setSectionsLoading(true);
    fetchSectionsForProjectDetails(activeProjectDetailsId)
      .then(setSections)
      .catch((err) => {
        console.error("Failed to fetch sections for project:", activeProjectDetailsId, err);
        setSections([]);
      })
      .finally(() => setSectionsLoading(false));
  }, [activeProjectDetailsId]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (searchInput !== filters.search) setFilter("search", searchInput);
    }, 350);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInput]);

  return (
    <div className="letters-filters">
      {!projectDetailsScopeId && (
        <select
          value={filters.project_details}
          onChange={(e) => {
            setFilters({ project_details: e.target.value, project: "" });
          }}
        >
          <option value="">All projects</option>
          {projectDetailsList.map((pd) => (
            <option key={pd.id} value={pd.id}>
              {pd.project_short_name || pd.project_name}
            </option>
          ))}
        </select>
      )}

      <select
        value={filters.project}
        onChange={(e) => setFilter("project", e.target.value)}
        disabled={!activeProjectDetailsId || sectionsLoading}
      >
        <option value="">{sectionsLoading ? "Loading sections…" : "All sections"}</option>
        {sections.map((s) => (
          <option key={s.id} value={s.id}>
            {s.section_name}
          </option>
        ))}
      </select>

      <select value={filters.status} onChange={(e) => setFilter("status", e.target.value)}>
        <option value="">All statuses</option>
        <option value="open">Open</option>
        <option value="closed">Closed</option>
      </select>

      <div className="letters-date-group">
        <span>From</span>
        <input type="date" value={filters.date_from} onChange={(e) => setFilter("date_from", e.target.value)} />
        <span>to</span>
        <input type="date" value={filters.date_to} onChange={(e) => setFilter("date_to", e.target.value)} />
      </div>

      <input
        type="text"
        placeholder="Search letter no. or description"
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />

      <button type="button" className="letters-clear-btn" onClick={clearFilters}>
        Clear filters
      </button>
    </div>
  );
}